import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_accessories_all: FaireCategoryEntity = {
  token: "cat_accessories-all",
  type: "category",
  name: "All accessories",
  level: 2,
  parentToken: "cat_accessories",
  href: "/category/accessories",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
